// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"6a79817f","335":"1e03c61f","377":"64641382","546":"18b0ac49","840":"3190e175"}[chunkId] + ".chunk.js";
};